var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrosshair = function SvgCrosshair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crosshair_svg__a",
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "crosshair_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crosshair_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#crosshair_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1c0-.6.4-1 1-1s1 .4 1 1v1.6c3.3.4 6 3.1 6.4 6.4H19c.6 0 1 .4 1 1s-.4 1-1 1h-1.6c-.4 3.3-3.1 6-6.4 6.4V19c0 .6-.4 1-1 1s-1-.4-1-1v-1.6C5.7 17 3 14.3 2.6 11H1c-.6 0-1-.4-1-1s.4-1 1-1h1.6C3 5.7 5.7 3 9 2.6V1zm6.5 9c0 3-2.5 5.5-5.5 5.5S4.5 13 4.5 10 7 4.5 10 4.5 15.5 7 15.5 10zM10 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })));
};
export default SvgCrosshair;